<template>
  <select
    size="1"
    v-model="model"
    v-focus="hasFocus"
  >
    <option v-for="{ value, displayName } in allOptions"
      :key="value"
      :value="value"
    >{{ displayName }}</option>
  </select>
</template>

<script>
import focusable from '@ssi/vue-common/src/mixins/focusable';
import { hasProps } from '@/helpers/util';

export default {
  mixins: [focusable],

  props: {
    includeEmpty: {
      type: Boolean,
      default: true
    },

    numeric: {
      type: Boolean,
      default: false
    },

    /**
     * Value should be an array of either simple values (strings or numbers)
     * or objects with "value" and "displayName" keys.
     * Examples:
     *  [1, 2, 3]
     *  ["one", "two", "three"]
     *  [{ value: "1", displayName: "one" }, { value: "2", displayName: "two" }]
     */
    options: {
      type: Array,
      required: true
    },

    value: [Object, String, Number]
  },

  computed: {
    model: {
      get: ({ value }) => value,

      set(newValue) {
        this.$emit('input', newValue);
      }
    },

    allOptions: ({
      includeEmpty, model, numeric, options
    }) => {
      const normalizedOptions = options
        // If options is an array of simple values, map it to objects.
        .map(o => (hasProps(o, ['value', 'displayName'])
          ? o
          : {
            value: o,
            displayName: o !== null ? String(o) : null
          }))
        // Select list values are always strings, so convert to Number if necessary.
        .map(o => (numeric
          ? { ...o, value: o.value !== null ? Number(o.value) : null }
          : o));

      return [
        // Optionally include an initial empty option.
        (includeEmpty ? { value: null, displayName: '' } : null),
        ...normalizedOptions,
        // If no option exists for the current value, add one.
        (model && !normalizedOptions.find(o => o.value === model)
          ? { value: model, displayName: model }
          : null)
      ].filter(o => !!o); // Remove nulls from above
    }
  }
};
</script>
